import React, { useCallback, useEffect, useState } from "react";
import {
  AreaClicavel,
  FileInput,
  FileUploadContainer,
  SpanMensagemErro,
  UploadButton,
  UploadIcon,
  UploadTextContainer,
} from "./style";

interface FileUploadProps {
  onFileUpload: (file: File) => void;
  onFilesUpload?: (files: File[]) => void;
  onLimpar?: () => void;
  multiple?: boolean;
  limparAoSelecionar?: boolean;
  textoSelecionado?: string;
  mensagemErro?: NullableString;
  id?: string;
  comMaxWidth?: boolean;
  gapContainer?: string;
  inputAccept?: string;
  limparArquivo?: boolean;
  fileInicial?: File | null;
  disabled?: boolean;
  textoBotao?: string;
}

function FileUpload({
  onFileUpload,
  onFilesUpload,
  onLimpar,
  multiple = false,
  limparAoSelecionar = false,
  textoSelecionado,
  mensagemErro,
  id = "fileInput",
  comMaxWidth = true,
  gapContainer = "0.5rem",
  inputAccept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  limparArquivo,
  fileInicial = null,
  disabled = false,
  textoBotao = "Upload",
}: FileUploadProps) {
  const [selectedFile, setSelectedFile] = useState<File | null>(fileInicial);

  const handleFileChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement> | null) => {
      if (!event && limparArquivo) {
        setSelectedFile(null);
        return;
      }

      const files = Array.from(event?.target.files ?? []);
      if (!files.length) return;

      if (multiple) {
        onFilesUpload?.(files);
        // Mantém o placeholder e limpa o input para permitir adicionar mais arquivos
        if (event) event.target.value = "";
        return;
      }

      const file = files[0];
      setSelectedFile(file);
      onFileUpload(file);
    },
    [onFileUpload, onFilesUpload, multiple, limparArquivo],
  );

  const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
    if (!limparAoSelecionar) return;
    setSelectedFile(null);
    event.currentTarget.value = "";
    onLimpar?.();
  };

  useEffect(() => {
    if (limparArquivo) {
      handleFileChange(null);
    }
  }, [limparArquivo, handleFileChange]);

  return (
    <FileUploadContainer gap={gapContainer}>
      <FileInput
        accept={inputAccept}
        id={id}
        type="file"
        multiple={multiple}
        onClick={handleClick}
        onChange={handleFileChange}
        disabled={disabled}
      />
      <AreaClicavel htmlFor={id}>
        <UploadTextContainer comErro={!!mensagemErro} comMaxWidth={comMaxWidth}>
          {textoSelecionado ?? selectedFile?.name ? (
            <span>{textoSelecionado ?? selectedFile?.name}</span>
          ) : (
            <span>Selecione o arquivo</span>
          )}
        </UploadTextContainer>
        <UploadButton comErro={!!mensagemErro}>
          <UploadIcon $comTexto={!!textoBotao} />
          {textoBotao}
        </UploadButton>
      </AreaClicavel>
      {mensagemErro && <SpanMensagemErro>{mensagemErro}</SpanMensagemErro>}
    </FileUploadContainer>
  );
}

export default FileUpload;
